import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { ICalendarEventState } from '../state/calendar-event.state';
import { adapter } from '../reducers/calendar-event.reducer';

const selectCalendarEvents = (state: IAppState) => state.calendarEvents;
export const selectCalendarEventState =
  createFeatureSelector<ICalendarEventState>('calendarEvents');

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

// select the dictionary of user entities
export const selectCalendarEventEntities = createSelector(
  selectCalendarEvents,
  selectEntities,
);
// select the array of users
export const selectAllCalendarEvents = createSelector(
  selectCalendarEvents,
  selectAll,
);

export const getSelectedCalendarEvent = createSelector(
  selectCalendarEvents,
  (state: ICalendarEventState) => state.selectedCalendarEvent,
);

export const selectLoading = createSelector(
  selectCalendarEvents,
  (state: ICalendarEventState) => state.loading,
);
export const selectLoaded = createSelector(
  selectCalendarEvents,
  (state: ICalendarEventState) => state.loaded,
);
export const selectError = createSelector(
  selectCalendarEvents,
  (state: ICalendarEventState) => state.error,
);

export const selectViewDateRange = createSelector(
  selectCalendarEvents,
  (state: ICalendarEventState) => ({
    startDate: state.viewStartDate ? new Date(state.viewStartDate) : null,
    endDate: state.viewEndDate ? new Date(state.viewEndDate) : null,
  }),
);
